import React from "react";
import { portfolioData } from "../data/portfolioData";
import { motion } from "framer-motion";

const Projects = () => {
  const { projects, sections } = portfolioData;

  return (
    <section id="projects" className="py-16 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-bold text-white">{sections.projectsTitle}</h2>
        <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project) => (
            <motion.article
              key={project.name}
              whileHover={{
                y: -8,
                boxShadow: "0 0 30px rgba(34, 211, 238, 0.25)",
                borderColor: "rgba(103, 232, 249, 0.8)",
              }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="rounded-2xl border border-slate-700/60 bg-slate-900/60 p-6"
            >
              <p className="text-xs uppercase tracking-[0.2em] text-cyan-300">{project.tech}</p>
              <h3 className="mt-3 text-xl font-semibold text-white">{project.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">
                {project.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
